export const iconFontAwesomeTransportationHelicopter = (
	<i className="fa-solid fa-helicopter"></i>
);
